import { useEffect, useState, useCallback, useRef, ReactNode } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from "../hook";
import React, { Suspense } from "react";
import Cookies from 'js-cookie';
import { login, logout, updateIsRequest, updateUserData } from "../slice/authSlice";
import Loader from '../Ui/Loader/Loader';
import { deleteRoleState, saveRoleState } from '../slice/roleMatrix';
import { getUserInfo, refreshToken } from '../../common/api/authApi';


interface IRedirectAuthorization {
  children: ReactNode;
}

export const RedirectAuthorization: React.FC<IRedirectAuthorization> = ({ children }) => {
  const [isLoginCheck, setIsLoginCheck] = useState<boolean>(true);
  // const [isRequesting, setIsRequesting] = useState(false);
  const userData = useAppSelector(state => state.auth.userData.firstname);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  const isInitialMount = useRef(true);
  const [isLoading, setIsLoading] = useState(true);
  const refresh_token = Cookies.get("refresh_token");
  


  const clearCookies = () => {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    Cookies.remove("token_expiry");
    Cookies.remove("SESSION", { path: "/", domain: ".edge-apps.com" });
    Cookies.remove("refresh_token", { path: "/", domain: ".edge-apps.com" });
  }

  useEffect(() => {
    if (!isLoading) return;
    setIsLoading(true); 

    const currentTime = Math.floor(Date.now() / 1000);
    const access_token = Cookies.get("access_token");
    const tokenExpiry = Cookies.get("token_expiry");
    const refresh_token = Cookies.get("refresh_token");

    if (!access_token && !refresh_token) {
      clearCookies();
      setIsLoginCheck(false);
      dispatch(deleteRoleState)
      dispatch(logout());
      navigate('/authorization');
      return;
    }

    const expiryTime = tokenExpiry ? parseInt(tokenExpiry, 10) : currentTime;
    if (currentTime >= expiryTime - 1200) {
      
      if (refresh_token) {
        refreshToken(refresh_token)
          .then((res) => {
            Cookies.remove("refresh_token", { path: "/", domain: ".edge-apps.com" });
            Cookies.remove("token_expiry");
            console.log(4324234,  res.data.refresh_token);

            Cookies.set("access_token", res.access_token);
            Cookies.set("refresh_token", res.refresh_token);
            Cookies.set("token_expiry", String(res.refresh_expires_in + currentTime));
            dispatch(login());
            setIsLoginCheck(true);
          })
          .catch((refreshError) => {
            clearCookies();
            setIsLoginCheck(false);
            dispatch(deleteRoleState)
            dispatch(logout());
            navigate('/authorization');
          });
      } else {
        clearCookies();
        setIsLoginCheck(false);
        dispatch(deleteRoleState)
        dispatch(logout());
        navigate('/authorization');
      }
    } else {
      dispatch(login());
      setIsLoginCheck(true);
    }
    
    if (!userData) {
      getUserInfo()
        .then(response => {
          dispatch(updateUserData(response));
        })
        .catch(error => {
          dispatch(deleteRoleState);
          dispatch(logout());
          setIsLoginCheck(false);
          clearCookies();
          navigate('/authorization');
        });
    }

    setIsLoading(false);
  }, [navigate, location.pathname, param]);

  if (isLoading) return <Loader/>;


  if (!isLoginCheck || !refresh_token) {
    return <Navigate to="/authorization" />;
  }

  return <>{children}</>; 
};